import React from 'react';
import styles from '../../styles/components/layout/alert-marquee.module.css';

interface AlertMarqueeProps {
  // message?: string;
  todayWarning?: number;
  totalWarning?: number;
  speed?: number; // 滚动速度，单位为秒，默认15秒
  pauseOnHover?: boolean; // 是否在悬停时暂停，默认true
}

const AlertMarquee: React.FC<AlertMarqueeProps> = ({
  // message = '今天出现异常记录12条累计115条，待整改33条，请抓紧处理',
  todayWarning = 0,
  totalWarning = 0,
  speed = 15,
  pauseOnHover = true
}) => {
  // const [alertMessage] = useState(message);
  const alertMessage = `今天出现异常记录${todayWarning}条，累计${totalWarning}条，请抓紧处理`;
  return (
    <footer
      className={styles.marquee}
      style={{
        '--marquee-speed': `${speed}s`,
        '--pause-on-hover': pauseOnHover ? 'paused' : 'running'
      } as React.CSSProperties}
    >
      <div className={styles.marqueeTrack}>
        {/* <div className={styles.marqueeContainer}> */}
          <div className={styles.marqueeContent}>
            {alertMessage}
          {/* </div> */}
        </div>
      </div>
    </footer>
  );
};

export default AlertMarquee;